// @ts-nocheck
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { PopulateApiParameter, chain } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import removeNotInCatalogLines from "@store/Framework/Common/Utilities/removeNotInCatalogLines";
import handleLinePropertiesForReorder from "@store/Framework/Common/Utilities/handleLinePropertiesForReorder";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, PopulateApiParameter, props => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);

    if (order.value) {
        handleLinePropertiesForReorder(order.value.orderLines, props.apiParameter.cartLines);
        props.apiParameter.cartLines = removeNotInCatalogLines(props.apiParameter.cartLines);
    }
});
